import { SkeletonFrame } from '@nextgen-web-framework/all';
import { ShopFinderContainer } from '@commerce-webcomponents/ui';
import useShopFetchLocations from './useShopFetchLocations';
import styles from './ShopFinder.module.scss';
const ShopFinder = () => {
  const { shopLocations, isFetchingShopDetails, isLocationAccessAllowed } = useShopFetchLocations();
  return isFetchingShopDetails ? (
    <SkeletonFrame heightValue={'600'} className={styles['shop-finder-skeleton']} />
  ) : (
    <ShopFinderContainer shopLocations={shopLocations} isLocationAccessAllowed={isLocationAccessAllowed} />
  );
};

export default ShopFinder;
